import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action } from '@ember/object';

import DacTypeTab from '../components/tab-content/dac-type';
import ApplicationParametersTab from '../components/tab-content/application-parameters';
import CircuitDesignTab from '../components/tab-content/circuit-design';
import { scheduleOnce, next } from '@ember/runloop';

import ENV from '../config/environment';
import Constants from '../utils/constants';

const queryParamList = [{ lang: 'en' }];
const TAB_CLASSES = {
  'dac-type': DacTypeTab,
  'application-parameters': ApplicationParametersTab,
  'circuit-design': CircuitDesignTab,
};

export default class IndexController extends Controller {
  @service hashService;
  @service intl;
  @service tabService;
  @service validationService;

  queryParams = queryParamList;
  lang = null;

  get dacType() {
    const type = this.model.signalChainHandler.dac.type;
    if (!type) return '';
    return this.intl.t(`labels.parts.${type.appName}`);
  }

  get activeTab() {
    return this.tabService.tabs.find((t) => t.isSelected).name;
  }

  get isAppParametersDisabled() {
    return this.tabService.tabs[1].isDisabled(
      this.model.signalChainHandler.dac.selected,
    );
  }

  get isAppParametersError() {
    return this.validationService.errorsExistByTabIndex(
      Constants.TAB_INDEXES.APP_PARAMS,
    );
  }

  get isCircuitDesignDisabled() {
    return this.tabService.tabs[2].isDisabled(
      this.model.signalChainHandler.dac.selected,
    );
  }

  get isCircuitDesignError() {
    return this.validationService.errorsExistByTabIndex(
      Constants.TAB_INDEXES.CIRCUIT_DESIGN,
    );
  }

  get tabClass() {
    return TAB_CLASSES[this.tabService.selected.name];
  }

  @action updateAppData() {
    // eslint-disable-next-line ember/no-runloop
    scheduleOnce('afterRender', this, '_updateAppData');
  }

  @action selectTab(tabKey) {
    const selectedTab = this.tabService.getTabByKey(tabKey);
    if (selectedTab.name !== this.activeTab) {
      this.tabService.goToTab(selectedTab);
    }
  }

  _updateAppData() {
    this.validationService.validateModel(this.model);

    /**
     * Updating the hash when running unit tests messes with Ember's method of organizing tests in the browser.
     * We will have to figure out something if we want to test the updating of the hash
     */
    // eslint-disable-next-line ember/no-runloop
    if (ENV.environment !== 'test') next(this, () => this.hashService.updateHash(this.model));
  }
}
